import { render, staticRenderFns } from "./Upper.vue?vue&type=template&id=496e8b3a"
import script from "./Upper.vue?vue&type=script&lang=js"
export * from "./Upper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports